// extracted by mini-css-extract-plugin
export var active = "_be-7";
export var container = "_be-0";
export var evenWidth = "_be-4";
export var large = "_be-5";
export var outlet = "_be-8";
export var slide = "_be-2";
export var small = "_be-6";
export var tab = "_be-3";
export var tabs = "_be-1";